export enum ReservationStatus {
	Open = 1,
	Selected = 2,
	Cancelled = 3,
	Expired = 4
}



// WEBPACK FOOTER //
// ./src/app/models/reservation-status.enum.ts